export default __webpack_public_path__ + "static/media/presentBoy.37f030b5.jpg";